/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { fetchDate } from "../../../utils/globleFunc";
import {
  Shield,
  Check,
  X,
  RefreshCw,
  Lock,
  Info,
  ShieldCheck,
  Eye,
  Image as ImageIcon,
  FileText,
  Copy,
  Eye as EyeIcon,
  EyeOff,
  ShieldOff,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationKeepsafe({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const products = useSelector((state) => state.ProductsReducer);
  const [isKeepsafeActive, setIsKeepsafeActive] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    if (store) {

      setIsKeepsafeActive(Boolean(store.security));
    }
  }, [store]);

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();
    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, []);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.confirmChat.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleDChange = () => {
    setData({ ...data, security: !data.security });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if we're activating or deactivating
    const isActivating = data.security;
    const isDeactivating = !data.security && isKeepsafeActive;

    if (isDeactivating) {
      // If deactivating, confirm with user
      const result = await showAlert(
        "warning",
        t("servicePageActivation.keepsafe.alerts.deactivateConfirm.title"),
        t("servicePageActivation.keepsafe.alerts.deactivateConfirm.text"),
        true,
        t("servicePageActivation.keepsafe.alerts.deactivateConfirm.confirmButton")
      );

      // If user cancels the confirmation, stop the process
      if (!result.isConfirmed) {
        // Reset toggle to previous state
        setData({ ...data, security: true });
        return;
      }
    }

    try {
      setLoading(true);
      await apicache(account, products);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);
      setIsKeepsafeActive(isActivating);

      if (isDeactivating) {
        await showAlert("success", t("servicePageActivation.keepsafe.alerts.saveSuccess"));
      } else if (isActivating) {
        await showAlert("success", t("servicePageActivation.keepsafe.alerts.saveSuccess"));
      } else {
        await showAlert("success", t("servicePageActivation.keepsafe.alerts.saveSuccess"));
      }
      close();
    } catch (error) {
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "error",
          t("servicePageActivation.keepsafe.alerts.saveError.title"),
          t("servicePageActivation.keepsafe.alerts.saveError.text")
        );
      } else {
        await showAlert(
          "error",
          t("servicePageActivation.keepsafe.alerts.saveError.title"),
          t("servicePageActivation.keepsafe.alerts.saveError.text")
        );
      }

      console.error("Error saving KeepSafe settings:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.keepsafe.alerts.premiumOnly.title"),
      t("servicePageActivation.keepsafe.alerts.premiumOnly.text"),
      true,
      t("servicePageActivation.keepsafe.alerts.premiumOnly.confirmButton")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  // Content protection features that KeepSafe provides
  const protectionFeatures = [
    {
      title: t("servicePageActivation.keepsafe.benefits.image_protection_title"),
      description: t(
        "servicePageActivation.keepsafe.benefits.image_protection_description"
      ),
      icon: <ImageIcon className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t("servicePageActivation.keepsafe.benefits.text_protection_title"),
      description: t(
        "servicePageActivation.keepsafe.benefits.text_protection_description"
      ),
      icon: <FileText className="text-blue-500" size={20} />,
    },
    {
      title: t("servicePageActivation.keepsafe.benefits.design_protection_title"),
      description: t(
        "servicePageActivation.keepsafe.benefits.design_protection_description"
      ),
      icon: <Copy className="text-green-500" size={20} />,
    },
  ];

  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center dark:!bg-[#1f1f1f] dark:!border-[#2a2a2a]">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center dark:!bg-[#3a300f]">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3 dark:!text-[#b47ed6]">
              {t("servicePageActivation.keepsafe.kepSafeLockSection.title")}
            </h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto dark:!text-gray-300">
              {t("servicePageActivation.keepsafe.kepSafeLockSection.description")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.keepsafe.kepSafeLockSection.button")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6"  >
      <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!bg-[#1f1f1f] dark:!border-[#2a2a2a]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center dark:!text-[#b47ed6]">
            <Shield className="ml-2" size={20} />
            {t("servicePageActivation.keepsafe.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-300">
            {t("servicePageActivation.keepsafe.description")}
          </p>
        </div>

        {/* Service Status Indicator */}
        <div
          className={`mb-4 p-3 rounded-lg ${isKeepsafeActive
            ? "bg-green-50 border border-green-200 dark:!bg-[#1a2b1a] dark:!border-[#2e4b2e]"
            : "bg-gray-50 border border-gray-200 dark:!bg-[#1f1f1f] dark:!border-[#2a2a2a]"
            }`}
        >
          <div className="flex items-center gap-x-2">
            <div
              className={`w-3 h-3 rounded-full mr-2 ${isKeepsafeActive ? "bg-green-500" : "bg-gray-400"
                }`}
            ></div>
            <span
              className={`text-sm font-medium ${isKeepsafeActive ? "text-green-700 dark:!text-green-400" : "text-gray-700 dark:!text-gray-400"
                }`}
            >
              {isKeepsafeActive
                ? t("servicePageActivation.keepsafe.status.active")
                : t("servicePageActivation.keepsafe.status.inactive")}
            </span>
          </div>
        </div>

        {/* Main Info Box */}
        <div className="bg-blue-50 rounded-lg border border-blue-200 p-4 flex mb-6 dark:!bg-[#1a2535] dark:!border-[#2a3b55]">
          <Info size={20} className="text-blue-500 ml-2 flex-shrink-0 mt-1" />
          <div>
            <p className="font-medium text-blue-800 mb-1 dark:!text-blue-400">
              {t("servicePageActivation.keepsafe.infoBox.title")}
            </p>
            <p className="text-blue-700 text-sm dark:!text-blue-300">
              {t("servicePageActivation.keepsafe.infoBox.description")}
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <div className="flex justify-between items-center mb-4">
              <label className="block text-sm font-medium text-[#9e68ba] dark:!text-[#b47ed6]">
                {t("servicePageActivation.keepsafe.toggle.label")}
              </label>
              <div
                className={`px-2 py-1 rounded-full text-xs font-medium ${data.security
                    ? "bg-green-100 text-green-800 dark:!bg-[#1a2b1a] dark:!text-green-400"
                    : "bg-gray-100 text-gray-800 dark:!bg-[#2a2a2a] dark:!text-gray-400"
                  }`}
              >
                {data.security
                  ? t("servicePageActivation.keepsafe.toggle.active")
                  : t("servicePageActivation.keepsafe.toggle.inactive")}
              </div>
            </div>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${data.security
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#241a2e] dark:!border-[#3d2b4f]"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#1f1f1f] dark:!border-[#2a2a2a] dark:hover:!bg-[#262626]"
                }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input type="checkbox" checked={data.security} onChange={() => { }} className="hidden" id="toggle" />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${data.security ? "bg-purple-400" : ""
                    }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${data.security ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                      }`}
                  />
                </label>
              </div>
              <div>
                <div className="flex items-center">
                  {data.security ? (
                    <ShieldCheck size={18} className="ml-2 text-[#9e68ba]" />
                  ) : (
                    <ShieldOff size={18} className="ml-2 text-gray-500" />
                  )}
                  <p className="font-medium">
                    {data.security
                      ? t("servicePageActivation.keepsafe.toggle.enabled.title")
                      : t("servicePageActivation.keepsafe.toggle.disabled.title")}
                  </p>
                </div>
                <p className="text-sm text-gray-500 mt-1 dark:!text-gray-400">
                  {data.security
                    ? t("servicePageActivation.keepsafe.toggle.enabled.description")
                    : t("servicePageActivation.keepsafe.toggle.disabled.description")}
                </p>
              </div>
            </div>
          </div>

          {/* Security Status */}
          <div
            className={`p-4 rounded-lg ${data.security
                ? "bg-green-50 border border-green-200 dark:!bg-[#1a2b1a] dark:!border-[#2e4b2e]"
                : "bg-red-50 border border-red-200 dark:!bg-[#2a1a1a] dark:!border-[#4b2e2e]"
              }`}
          >
            <div className="flex items-center mb-2">
              {data.security ? (
                <EyeOff className="text-green-500 ml-2" size={24} />
              ) : (
                <EyeIcon className="text-red-500 ml-2" size={24} />
              )}
              <h4 className="font-medium text-gray-800 text-lg dark:!text-gray-200">
                {data.security
                  ? t("servicePageActivation.keepsafe.statusBox.active.title")
                  : t("servicePageActivation.keepsafe.statusBox.inactive.title")}
              </h4>
            </div>
            <p className="text-sm text-gray-700 dark:!text-gray-400">
              {data.security
                ? t("servicePageActivation.keepsafe.statusBox.active.description")
                : t("servicePageActivation.keepsafe.statusBox.inactive.description")}
            </p>
          </div>

          {/* Protection Features */}
          {data.security && (
            <div className="space-y-4">
              <h4 className="font-medium text-[#9e68ba] dark:!text-[#b47ed6]">
                {t("servicePageActivation.keepsafe.features.title")}
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {protectionFeatures.map((feature, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm dark:!bg-[#1f1f1f] dark:!border-[#2a2a2a]"
                  >
                    <div className="flex items-center mb-2">
                      {feature.icon}
                      <h5 className="font-medium text-gray-800 mr-2 text-sm dark:!text-gray-200">{feature.title}</h5>
                    </div>
                    <p className="text-xs text-gray-600 dark:!text-gray-400">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Before/After Example */}
          {data.security && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4 bg-gray-50 rounded-lg border border-gray-200 dark:!bg-[#1f1f1f] dark:!border-[#2a2a2a]">
              {/* Without Protection */}
              <div className="space-y-2">
                <div className="flex items-center">
                  <ShieldOff size={18} className="text-red-500 ml-2" />
                  <h5 className="font-medium text-gray-800 dark:!text-gray-200">
                    {t("servicePageActivation.keepsafe.comparison.without.title")}
                  </h5>
                </div>
                <div className="bg-white border border-red-200 rounded-lg p-3 relative dark:!bg-[#241a1a] dark:!border-[#3d2b2b]">
                  <div className="absolute top-2 left-2 bg-red-100 text-red-700 text-xs px-2 py-1 rounded">
                    {t("servicePageActivation.keepsafe.comparison.without.label")}
                  </div>
                  <div className="pt-6">
                    {["0", "1", "2"].map((point) => (
                      <p key={point} className="text-sm text-gray-700 mb-2 dark:!text-gray-400">
                        {t(`servicePageActivation.keepsafe.comparison.without.points.${point}`)}
                      </p>
                    ))}
                  </div>
                </div>
              </div>

              {/* With Protection */}
              <div className="space-y-2">
                <div className="flex items-center">
                  <ShieldCheck size={18} className="text-green-500 ml-2" />
                  <h5 className="font-medium text-gray-800 dark:!text-gray-200">
                    {t("servicePageActivation.keepsafe.comparison.with.title")}
                  </h5>
                </div>
                <div className="bg-white border border-green-200 rounded-lg p-3 relative dark:!bg-[#1a241a] dark:!border-[#2b3d2b]">
                  <div className="absolute top-2 left-2 bg-green-100 text-green-700 text-xs px-2 py-1 rounded">
                    {t("servicePageActivation.keepsafe.comparison.with.label")}
                  </div>
                  <div className="pt-6">
                    {["0", "1", "2"].map((point) => (
                      <p key={point} className="text-sm text-gray-700 mb-2 dark:!text-gray-400">
                        {t(`servicePageActivation.keepsafe.comparison.with.points.${point}`)}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Tips Section */}
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100 dark:!bg-[#2a2415] dark:!border-[#4a3b20]">
            <h4 className="font-medium text-lg text-yellow-800 mb-2 flex items-center dark:!text-yellow-400">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.keepsafe.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-400">
              {["0", "1", "2", "3"].map((tip) => (
                <li key={tip}>{t(`servicePageActivation.keepsafe.tips.list.${tip}`)}</li>
              ))}
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-3 ${data.security !== isKeepsafeActive
                ? data.security
                  ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                  : "bg-red-500 hover:bg-red-600"
                : "bg-gray-400"
              } text-white rounded-lg transition-colors flex items-center justify-center ${loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {data.security
                  ? t("servicePageActivation.keepsafe.submit.activating")
                  : t("servicePageActivation.keepsafe.submit.deactivating")}
              </>
            ) : (
              <>
                {data.security !== isKeepsafeActive ? (
                  data.security ? (
                    <>
                      <ShieldCheck className="ml-2" size={18} />
                      {t("servicePageActivation.keepsafe.submit.activate")}
                    </>
                  ) : (
                    <>
                      <ShieldOff className="ml-2" size={18} />
                      {t("servicePageActivation.keepsafe.submit.deactivate")}
                    </>
                  )
                ) : (
                  <>
                    <Info className="ml-2" size={18} />
                    {t("servicePageActivation.keepsafe.submit.noChange")}
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
